import apiClient from '../api/apiClient'
import { User, LoginForm, ApiResponse } from '../../types'

export const authService = {
  async login(credentials: LoginForm): Promise<ApiResponse<{ user: User; token: string }>> {
    const response = await apiClient.post<ApiResponse<{ user: User; token: string }>>(
      '/auth/login',
      credentials
    )
    console.log("Login response:", response)
    return response.data
  },

  async signup(userData: any): Promise<{ user: User; token: string }> {
    const response = await apiClient.post<ApiResponse<{ user: User; token: string }>>(
      '/auth/signup',
      userData
    )
    return response.data.data
  },

  async getCurrentUser(): Promise<any> {
    const response = await apiClient.get('/auth/me')
    return response.data
  },

  async logout(): Promise<void> {
    // JWT-based auth: logout is handled client-side by removing token
    // No server-side call needed
    return Promise.resolve()
  },
}
